import { Box, Card } from '@mui/material';
import React from 'react';
import { Table } from '../../../../../components';
import DeviceColumns from '../columns/DeviceColumns';

const DeviceSection = ({ devices, isLoading }) => {
    return (
        <Card sx={{ paddingTop: '1rem', boxShadow: 'none' }}>
            <Box padding={'2.25rem 0'}>
                <Table
                    data={devices}
                    columns={DeviceColumns()}
                    isLoading={isLoading}
                    total={devices.length}
                />
            </Box>
        </Card>
    );
};

export default DeviceSection;
